import React, { Component } from 'react';
import { convertEffectValuesToStyles } from '../helpers/TextEffectsHelper';
class ContentEditable extends Component{
  
  render(){
    
    var styles = this.props.styles;
    styles.fontSize = (parseFloat( styles.fontSize, 10) * this.props.zoomFactor).toFixed(2) + "px";
    styles.fontFamily += ", gfs";
    var dir = "auto";
    
    if(this.props.otherOptions.get("isRTL")){
      dir = "rtl";
    }

    return(<div className={this.props.classes} ref={(e) => this.htmlContent = e } style={styles} contentEditable={this.props.isEditable} data-id = {this.props.dataId} data-group-id = {this.props.dataGroupId} dangerouslySetInnerHTML={{__html: this.props.html}} dir={dir}></div>);
  }
}


export default class TextComponent extends Component{

  render(){
   
    var styles    = this.props.text.getIn(["textData", "formats", "containerStyle"]).toObject();
    
    var classes = "text-container scene-item-inner";
    
    if(styles.margin !== undefined)
      styles.margin = (parseFloat( styles.margin, 10) * this.props.zoomFactor).toFixed(2) + "px";

    if(styles.letterSpacing !== undefined && this.props.isBullet){
      styles.paddingLeft = (parseFloat( styles.letterSpacing, 10) * 3).toFixed(2) + "em";
    }
    if(this.props.text.getIn(["textData", "formats", "others", "isRTL"])){
      classes += " rtl-text";
    }
    let padding = 0
    if(this.props.text.getIn(["textData", "formats", "bullet", "type"]) !== "none" || this.props.text.getIn(["textData", "formats", "bullet", "type"]) !== ""){
      if(this.props.text.getIn(["textData", "formats", "bullet", "bulletSpace"]) !== undefined){
        classes += " bspace"+this.props.text.getIn(["textData", "formats", "bullet", "bulletSpace"]);
        padding = this.props.text.getIn(["textData", "formats", "bullet", "bulletSpace"])
      }
    }
    padding = padding * this.props.zoomFactor
    styles['--paddingSpace'] = padding + 'px'

    if(this.props.text.get("yRatio") && this.props.isGrouped){
      
    }
    let innerX = this.props.text.get("innerX")?this.props.text.get("innerX"):0;
    let innerY = this.props.text.get("innerY")?this.props.text.get("innerY"):0;
    
    styles.transform = "translate("+ (innerX * this.props.zoomFactor) +"px, "+ (innerY * this.props.zoomFactor) +"px)";
    const currentEffects = this.props.text.getIn(["textData", "effects"]);
    const fontSize = this.props.text.getIn(["textData", "formats", "containerStyle", "fontSize"]);
    const fontColor = this.props.text.getIn(["textData", "formats", "containerStyle", "color"]);
    if(currentEffects !== "None" && currentEffects !== undefined){
      var effect = convertEffectValuesToStyles(currentEffects.toJS(), fontSize, fontColor);
      // console.log("effect", effect)
      styles.textShadow = effect.textShadow;
      styles.webkitTextFillColor = effect.webkitTextFillColor;
      styles.webkitTextStroke = effect.webkitTextStroke;
      styles.filter = effect.filter;
    }
      
    return(<ContentEditable dataId = {this.props.data_id} textId = {this.textId} isEditable={false} height = {this.props.text.get("height")} otherOptions = {this.props.text.getIn(["textData", "formats", "others"])} zoomFactor = {this.props.zoomFactor} dataGroupId = {this.props.itemId} html={this.props.text.getIn(["textData", "htmlText"])} isBullet = {this.props.text.getIn(["textData", "formats", "bullet", "type"]) !== "none"} classes = {classes} styles={styles}/>);
  }
}



// WEBPACK FOOTER //
// ./src/components/TextComponent.js